import { render, staticRenderFns } from "./WorkRecord.vue?vue&type=template&id=f21a267c&"
import script from "./WorkRecord.vue?vue&type=script&lang=js&"
export * from "./WorkRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports